<template>
  <div
    id="div-hre-Embeds-4863"
    class="publirAds"></div>
</template>

<script>
/* eslint-disable no-undef */

export default {
  name: "PublirAd",
  mounted() {
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener("slotRenderEnded", (event) => {
        if (event.slot.getSlotElementId() === "div-hre-Embeds-4863") {
          googletag.display("div-hre-Embeds-4863");
        }
      });
      googletag.display("div-hre-Embeds-4863");
    });
  },
};
</script>
